
interface FinalCTAProps {
  onCTAClick: () => void;
}

export default function FinalCTA({ onCTAClick }: FinalCTAProps) {
  return (
    <section className="bg-[#1A1F36] py-24 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#FF6B35]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#FF6B35]/5 rounded-full blur-2xl"></div>
      
      <div className="max-w-[700px] mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/20 rounded-full text-sm mb-8">
          <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full animate-pulse"></span>
          <span className="text-white/90 font-medium">Free for UK Businesses</span>
        </div>
        
        <h2 className="text-4xl lg:text-[44px] font-bold text-white mb-5 leading-tight">
          Ready to Attract <span className="text-[#FF6B35]">Better Work?</span>
        </h2>
        
        <p className="text-xl text-white/70 mb-10">
          Get your free digital review and see exactly what's holding you back.
        </p>
        
        <button 
          onClick={onCTAClick}
          className="group px-12 py-4 bg-[#FF6B35] text-white text-lg font-semibold rounded-full hover:bg-[#E85A2A] hover:shadow-[0_8px_30px_rgba(255,107,53,0.4)] hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
        >
          Get Your Free Review
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
        </button>
        
        <div className="mt-8 text-base text-white/60 flex items-center justify-center gap-6 flex-wrap">
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-[#FF6B35]"></i>
            No obligation
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-[#FF6B35]"></i>
            Results in 48 hours
          </span>
        </div>
      </div>
    </section>
  );
}
